import { Component, inject } from '@angular/core';
import { SoilSpecieService } from '../proxy/planning/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import { SOILSPECIE_CONFIG, SOILSPECIE_FIELDS } from './soil-specie.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';
import { SoilSpecieCreateDto, SoilSpecieDto, SoilSpecieExcelDownloadDto, SoilSpecieUpdateDto } from '../proxy/planning/dtos/soil-species';

@Component({
  selector: 'app-soil-specie',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, SoilSpecieService, ConfirmationService],
  templateUrl: './soil-specie.html',
  styleUrl: './soil-specie.scss',
})
export class SoilSpecie extends BaseCrudComponent<
  SoilSpecieDto,
  SoilSpecieCreateDto,
  SoilSpecieUpdateDto,
  SoilSpecieExcelDownloadDto
> {
  service = inject(SoilSpecieService);
  config = SOILSPECIE_CONFIG;
  fields = SOILSPECIE_FIELDS;

  protected prepareUpdateDto(data: any, selected: SoilSpecieDto): SoilSpecieUpdateDto {
    return {
      name: data.name,
      code: data.code,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'SoilSpecie';
  }
}
